import { AddIcon, CloseIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Heading,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Tooltip,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useToast,
  Image,
  SimpleGrid
} from "@chakra-ui/react";

import SearchAdaccountAdspresso from "components/bmControl/SearchAdaccountAdspresso";
import AdspressoCampaignForm from "components/campaignForms/AdspressoCampaignForm";
import AdspressoTable from "components/campaignTables/AdspressoTable";
import SidebarWithHeader from "components/SidebarWithHeader";
import { useFormik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCreateAdspressoCampaignMutation, useGetAdspressoCampaignsQuery } from "store/adspresso/adspressoCampaignApi";
import { useGetBmAdAccountsCountQuery, useGetBmAdAccountsQuery, useLogoutRelationMutation } from "store/BmAccounts/bmAccountApi";
import { useGetcampaignFormQuery } from "store/campaigns/campaignsApi";
import { campaignFormSchema } from "utils/schema";
import {
  selectFbData,
  setRefetchFbData,
  setSelectedBmAccounts,
} from "store/BmAccounts/bmAccountSlice";
import { FaAngleRight } from "react-icons/fa";
import PinDark from "../assets/images/popup/1-DARK.png";
import PlusDark from "../assets/images/popup/2-dark.png";
import RocketDark from "../assets/images/popup/3-dark.png";
import StarDark from "../assets/images/popup/4-dark.png";
import PinLight from "../assets/images/popup/1-DARK-1.png";
import PlusLight from "../assets/images/popup/2-light.png";
import RocketLight from "../assets/images/popup/3-light.png";
import StarLight from "../assets/images/popup/4-light.png";
import moment from "moment";

const normalizeTimezone = (timezone) => {
  // Normalize timezone names like "Asia/Calcutta" to "Asia/Kolkata"
  const timezoneMapping = {
    "Asia/Calcutta": "Asia/Kolkata",
  };

  return timezoneMapping[timezone] || timezone;
};

function AdspressoForClient() {
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose: onModalClose } = useDisclosure();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQueryTriggered, setIsQueryTriggered] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [adAccounts, setAdAccounts] = useState([]);
  const [afterValue, setAftervalue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setsearchValue] = useState('');
  const [hasAdspressoData, setHasAdspressoData] = useState(false);
  const fBData = useSelector(selectFbData);
  const token = useSelector((state) => state.auth.userInfo?.token);
  const { colorMode } = useColorMode();
  const textColor = useColorModeValue("brand.900", "brand.500");
  const iconBg = useColorModeValue("brand.900", "card.dark");
  const accountListColor = useColorModeValue("gray.800", "brand.50");

  const steps = [
    {
      // img: colorMode === 'light' ? PinLight : PinDark,
      img: "🔗",
      label: "Connect your BM",
    },
    {
      img: "➕",
      label: "Create Ad Campaign via 'Launch Pad'",
    },
    {
      img: "🚀",
      label: "Launch Campaign",
    },
    {
      img: "🌟",
      label: "Get 30% better ROAS",
    },
  ];

  const { data: accountsCount } = useGetBmAdAccountsCountQuery();
  const totalCount = accountsCount?.summary?.total_count ?? 20;
  const isSearching = !!searchTerm?.trim();
  const effectivePageSize = isSearching ? String(totalCount) : "20";

  const { data: AdAccountData, refetch: refetchAdaccountData, isLoading: isAdAccountLoading, isFetching: isAdAccountFetching, error: AdAccountError, isError: isAdaccountError } = useGetBmAdAccountsQuery(
    {
      search: searchTerm ? searchTerm : '',
      pageSize: effectivePageSize,
      after: searchTerm ? '' : afterValue,
    },
  );

  const { data: dataCampaign, error: errorCampaign, isLoading: isLoadingCampaign } = useGetcampaignFormQuery(undefined, { skip: !isQueryTriggered });
  const [createCampaignData, { isLoading: isCreating, error: createError }] = useCreateAdspressoCampaignMutation();

  const {
    data: adspressoCampaigns,
    isLoading,
    isFetching
  } = useGetAdspressoCampaignsQuery({ currentPage, searchValue });

  const [logoutBmRelation, { isLoading: isLoggingOut }] = useLogoutRelationMutation();


  useEffect(() => {
    if (searchValue != '') {
      setCurrentPage(1);
    }
  }, [searchValue])

  const handleLogoutRelation = () => {
    logoutBmRelation()
      .unwrap()
      .then(() => {
        refetchAdaccountData();
        dispatch(setSelectedBmAccounts(null));
        dispatch(setRefetchFbData(true));
        localStorage.removeItem("fBData");

        toast({
          position: "top-right",
          title: "Disconnected successfully",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          position: "top-right",
          title: "Error in disconnecting FB",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const handleOpenFbBmModal = () => {
    if (token) {
      const fbRedirectUrl = `${process.env.REACT_APP_API_URL}facebook?state=${token}`;
      window.location.href = fbRedirectUrl;
    } else {
      toast({
        title: 'Authentication Error',
        description: 'Please log in to connect to Facebook.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (
      fBData?.status === 'deactive' && adspressoCampaigns?.data?.length === 0
    ) {
      onOpen();
    }
  }, [fBData, adspressoCampaigns]);


  // useEffect(() => {
  //   if (AdAccountError && fBData?.status === 'active') {
  //     toast({
  //       position: "top-right",
  //       title: "Error",
  //       description: AdAccountError?.data?.message,
  //       status: "error",
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //     navigate('/launchpad');
  //   }
  // }, [AdAccountError, fBData]);

  useEffect(() => {
    if (hasSearched && searchTerm === '') {
      refetchAdaccountData();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (AdAccountData) {
      const newAccounts = AdAccountData.data.filter(
        (account) => !adAccounts.some((existingAccount) => existingAccount.account_id === account.account_id)
      );
      setAdAccounts((prevAccounts) => [...prevAccounts, ...newAccounts]);;
    }
  }, [AdAccountData]);

  const campaignFormik = useFormik({
    initialValues: {
      adsAccounts: [],
      name: "",
      objective: "OUTCOME_LEADS",
      isAdvantageCampaignEnabled: false,
      isAdvantageCatalogueEnabled: false,
      isAdScheduled: false,
      accelerated: false,
      is_budget_schedule_enabled: false,
      budget_schedule_specs: [
        {
          time_start: moment().add(1, 'day').startOf('day').unix(),
          time_end: moment().add(2, 'day').startOf('day').unix(),
          budget_value_type: 'ABSOLUTE',
          budget_value: 5,
        },
      ],
      smart_promotion_type: 'MANUAL_LEAD',
      budget: 'daily_budget',
      product_catalog_id: '',
      bid_strategy: 'LOWEST_COST_WITHOUT_CAP',
      daily_budget: 800,
      lifetime_budget: 14000,
      status: "PAUSED",
    },
    validationSchema: campaignFormSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { name, objective, status, adsAccounts, smart_promotion_type, isAdvantageCampaignEnabled, isAdvantageCatalogueEnabled, product_catalog_id, accelerated, isAdScheduled, bid_strategy, budget, daily_budget, lifetime_budget, is_budget_schedule_enabled, budget_schedule_specs } = values;
      const modifiedAdsAccounts = adsAccounts.map(({ currency, ...rest }) => rest);

      const payload = {
        name,
        objective,
        status,
        currency : adsAccounts[0]?.currency,
        adsAccounts: modifiedAdsAccounts,
      };
      if (objective === 'OUTCOME_SALES' && smart_promotion_type === 'AUTOMATED_SHOPPING_ADS') {
        payload.smart_promotion_type = smart_promotion_type;
      }

      if (isAdvantageCatalogueEnabled) {
        payload.promoted_object = adsAccounts.map(({ adsAccountId }) => ({
          adsAccountId: adsAccountId,
          product_catalog_id: product_catalog_id
        }));
      }

      // Only add these fields if isAdvantageCampaignEnabled is true
      if (isAdvantageCampaignEnabled) {
        payload.bid_strategy = bid_strategy;

        if (budget === 'daily_budget') {
          payload.daily_budget = Number(daily_budget) * 100;
          if (adsAccounts.length > 0) {
            payload.currency = adsAccounts[0].currency;
          }
        }

        if (budget === 'lifetime_budget') {
          payload.lifetime_budget = Number(lifetime_budget) * 100;
          if (adsAccounts.length > 0) {
            payload.currency = adsAccounts[0].currency;
          }
        }

        payload.pacing_type = [];

        // Add "no_pacing" if accelerated
        if (accelerated) {
          payload.pacing_type.push("no_pacing");
        }

        // Add "day_parting" if ad is scheduled
        if (isAdScheduled) {
          payload.pacing_type.push("day_parting");
        }

        // If "no_pacing" is not included, default to "standard"
        if (!payload.pacing_type.includes("no_pacing")) {
          payload.pacing_type.push("standard");
        }

        if (is_budget_schedule_enabled) {
          payload.is_budget_schedule_enabled = is_budget_schedule_enabled;

          payload.budget_schedule_specs = budget_schedule_specs.map(spec => ({
            ...spec,
            budget_value: spec.budget_value_type === 'ABSOLUTE'
              ? Math.round(spec.budget_value * 100) // Convert dollars to cents
              : spec.budget_value // Leave as-is for MULTIPLIER (percentage)
          }));
        }

      }

      createCampaignData({ payload })
        .unwrap()
        .then((response) => {
          toast({
            position: "top-right",
            title: "Campaign created",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          resetForm();
          handleCloseModal();
          navigate(`/launchpad/${response.data._id}`);
        })
        .catch((error) => {
          toast({
            position: "top-right",
            title: "Error in creating",
            status: "error",
            description: error?.data?.message,
            duration: 4000,
            isClosable: true,
          });
        })
        .finally(() => {
          setSubmitting(false);
          localStorage.removeItem('selectedAdspressoAdsAccount');
          setSelectedAdAccounts([]);
          setAftervalue('');
        });
    },
  });

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setIsQueryTriggered(true);
  };

  const handleCloseModal = () => {
    campaignFormik.resetForm();
    setIsModalOpen(false);
    setIsQueryTriggered(false);
    setSelectedAdAccounts([]);
    setAftervalue('');
    localStorage.removeItem('selectedAdspressoAdsAccount');
  };


  const handleAdaccountChange = (value) => {

    if (value) {

      const isAlreadySelected = selectedAdAccounts.some(
        (account) => account?.adsAccountId === value?.account_id
      );

      if (!isAlreadySelected) {
        const accountDetails = {
          adsAccountName: value?.account?.name,
          adsAccountId: value?.account?.account_id,
          id: value?.account?.id,
          businessName: value?.account?.business?.name,
          businessId: value?.account?.business?.id,
          currency: value?.account?.currency,
          accountTimezone: value?.account?.timezone_name,
        };

        // Check for currency consistency by including the new account in the validation
        const currencies = [
          ...new Set([...selectedAdAccounts.map((account) => account.currency), accountDetails.currency])
        ];

        if (currencies.length > 1) {
          campaignFormik.setFieldError("adsAccounts", "Selected Ad Accounts have different currencies.");
          campaignFormik.setFieldTouched("adsAccounts", true, false);
          return; // Prevent adding the account if currencies are inconsistent
        }

        // Normalize and check for timezone consistency by including the new account in the validation
        const normalizedTimezones = [
          ...new Set([
            ...selectedAdAccounts.map((account) => normalizeTimezone(account.accountTimezone)),
            normalizeTimezone(accountDetails.accountTimezone),
          ]),
        ];

        if (normalizedTimezones.length > 1) {
          campaignFormik.setFieldError("adsAccounts", "Selected Ad Accounts have different timezones.");
          campaignFormik.setFieldTouched("adsAccounts", true, false);
          return; // Prevent adding the account if timezones are inconsistent
        }

        // Add the account to the selectedAdAccounts state
        setSelectedAdAccounts((prevState) => {
          const updatedAccounts = [accountDetails, ...prevState];

          // Update the form field with the new selected accounts (filtered)
          const filteredAccounts = updatedAccounts.map(({ accountTimezone, ...rest }) => rest);

          campaignFormik.setFieldValue("adsAccounts", filteredAccounts);
          return updatedAccounts;
        });
      }
    }

  };

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  // Function to remove an account from selectedAdAccounts
  const handleRemoveAdAccount = (accountId) => {
    // Remove the account from the selectedAdAccounts state
    setSelectedAdAccounts((prevState) => {
      const updatedAccounts = prevState.filter(account => account.adsAccountId !== accountId);

      // Update campaignFormik values (adsAccounts)
      // Remove the account from form values as well
      const filteredAccounts = updatedAccounts.map(({ accountTimezone, ...rest }) => rest);
      campaignFormik.setFieldValue("adsAccounts", filteredAccounts);

      return updatedAccounts;
    });
  };

  const handleLoadMore = (after) => {
    setAftervalue(after);
  };

  const handleAdspressoData = (adspressoData) => {
    if (adspressoData?.length > 0) {
      setHasAdspressoData(true);
    } else {
      setHasAdspressoData(false);
    }
  }

  return (
    <SidebarWithHeader>
      <>
        <Modal
          isOpen={isOpen} onClose={onModalClose} isCentered size={'3xl'} closeOnOverlayClick={false} closeOnEsc={false}>
          <ModalOverlay />
          <ModalContent
            bg={colorMode === 'light' ? "white" : "brand.900"}
          >
            <ModalBody alignItems={'center'} py={{ base: '20px', md: '40px' }}>
              <Box
                px={6}
                maxW="6xl"
                mx="auto"
                textAlign="center"
                color={textColor}
              >
                <Heading as="h1" size="xl" mb={2}>
                  Welcome to Hustle!
                </Heading>

                <Text fontSize="md" mb={{ base: 4, md: 10 }}>
                  Get that ad rolling, here's what you need to do
                </Text>

                <SimpleGrid
                  columns={{ base: 2, md: steps.length }}
                  spacing={{ base: 6, md: 0 }}
                  justifyItems="center"
                  mb="40px"
                >
                  {steps.map((step, index) => (
                    <Flex
                      key={index}
                      align="center"
                      direction="column"
                    >
                      <Flex
                        direction="column"
                        align="center"
                        w="120px"
                        minH={{ base: 'auto', md: "150px" }}
                        mx={{ md: 2 }}
                        mb={{ base: 2, md: 0 }}
                      >
                        <Box position="relative" mb={2}>
                          <Box
                            w="80px"
                            h="80px"
                            borderRadius="full"
                            bg={iconBg}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Text fontSize="40px" color={textColor}>
                              {step.img}
                            </Text>
                          </Box>

                          {index < steps.length - 1 && (
                            <Box
                              display={{ base: "none", md: "flex" }}
                              position="absolute"
                              top="40px"
                              right={{ base: "-60px", md: "-100px" }}
                              height="2px"
                              width={{ base: "60px", md: "120px" }}

                              bg={textColor}
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <Box position="absolute" right={{ base: 'auto', md: "35%" }} top="-6px">
                                <FaAngleRight color={textColor} size="14px" />
                              </Box>
                            </Box>
                          )}
                        </Box>

                        <Text textAlign="center" fontSize="sm">
                          {step.label}
                        </Text>
                      </Flex>
                    </Flex>
                  ))}
                </SimpleGrid>


                {/* <Button
                  size="sm"
                  colorScheme="brand"
                  onClick={onModalClose}
                >
                  Let's go
                </Button> */}
                <Flex align={"center"} justify="center" >
                  <Box pos="relative" role="group" w="100px" h="40px" >
                    <Box
                      as="button"
                      pos="absolute"
                      top="0"
                      left="0"
                      right="0"
                      bottom="0"
                      w="100%"
                      h="40px "
                      zIndex={2}
                      bg={colorMode === 'light' ? "brand.800" : "brand.500"}

                      transition="all 0.3s ease"
                      _groupHover={{
                        top: '-8px',
                        left: '-8px',
                      }}
                      borderRadius="25px"
                      cursor="pointer"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      fontWeight="bold"
                      color={useColorModeValue("white", "brand.900")}
                      onClick={onModalClose}
                      borderColor={colorMode === 'light' ? "brand.900" : "brand.900"}
                      borderWidth="1px"
                      variant={'outline'}
                    >
                      Let's go
                    </Box>

                    <Box
                      as="button"
                      bg="linear-gradient(90deg,rgba(56, 187, 230, 1) 0%, rgba(254, 113, 255, 1) 46%, rgba(237, 100, 121, 1) 63%, rgba(247, 235, 13, 1) 99%)"
                      pos="absolute"
                      top="0"
                      left="1px"
                      right="0"
                      bottom="0"
                      w={"calc(100% - 2px)"}
                      h="40px"
                      zIndex={1}
                      borderRadius="25px"
                      cursor="pointer"
                      outline="none"
                      border="none"
                    />
                  </Box>
                </Flex>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>

        <Modal isOpen={isModalOpen} onClose={handleCloseModal} size={{ base: 'full', md: '5xl' }}>
          <ModalOverlay />
          <ModalContent maxH={{ base: '90vh', md: 'unset' }} overflow="hidden">
            <ModalHeader>Ad Campaign Creation</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex
                direction={{ base: 'column', md: 'row' }}
                justify="space-between"
                gap={{ base: '16px', md: '20px' }}
              >
                {/* Left Section - Ad Accounts */}
                <Flex
                  direction="column"
                  flex={{ base: '100%', md: '30%' }}
                  overflowY="auto"
                  gap="5px"
                  minH="390px"
                  maxH={{ base: '300px', md: '390px' }}
                >
                  <Text fontWeight="bold">Choose Ad Accounts</Text>
                  <Text fontSize="12px" mb={1}>
                    Select one or more Ad Accounts with the same{" "}
                    <Text as="span" fontWeight="semibold">
                      Currency
                    </Text>{" "}
                    and{" "}
                    <Text as="span" fontWeight="semibold">
                      Timezone
                    </Text>{" "}
                    to launch campaigns in bulk
                  </Text>

                  {/* Ad Account Search */}
                  <SearchAdaccountAdspresso
                    onInitialisation={() => {}}
                    accountOptions={AdAccountData?.data}
                    onAccountChange={handleAdaccountChange}
                    onSearchInputChange={handleSearchChange}
                    onSearchInputTouched={setHasSearched}
                    AdsAccountIdFromParams={''}
                    isAdAccountLoading={isAdAccountLoading}
                    isAdAccountFetching={isAdAccountFetching}
                    pageMeta={AdAccountData?.meta}
                    onLoadMore={handleLoadMore}
                    selectedAccounts={selectedAdAccounts}
                    onRemoveAccount={handleRemoveAdAccount}
                  />

                  {/* Selected Accounts List */}
                  <Box overflowY="auto" mt={2}>
                    <Stack spacing={1} gap="4px">
                      {selectedAdAccounts.map((account) => (
                        <Flex key={account.adsAccountId} align="center" direction="row" gap={1}>
                          <Flex direction="column" align="flex-start" flex={0.9} pl={1}>
                            <Text fontSize="12px" fontWeight="bold">
                              {account?.adsAccountName?.length > 38
                                ? `${account.adsAccountName.substring(0, 38)}...`
                                : account?.adsAccountName}
                            </Text>
                            <Flex gap="5px">
                              <Text fontSize="10px" color={accountListColor}>
                                {account?.adsAccountId}
                              </Text>
                              <Text fontSize="10px" color={accountListColor} fontWeight="bold">
                                ({account?.currency})
                              </Text>
                            </Flex>
                          </Flex>

                          <Flex justify="flex-end" flex={0.1}>
                            <Tooltip label="Remove" aria-label="Remove account tooltip" fontSize="12px">
                              <IconButton
                                icon={<CloseIcon />}
                                size="sm"
                                variant="ghost"
                                colorScheme="red"
                                onClick={() => handleRemoveAdAccount(account.adsAccountId)}
                                aria-label="Remove account"
                              />
                            </Tooltip>
                          </Flex>
                        </Flex>
                      ))}
                    </Stack>
                  </Box>
                </Flex>

                {/* Divider for desktop */}
                <Box
                  borderLeft={{ base: 'none', md: '1px solid #ccc' }}
                  borderBottom={{ base: '1px solid #ccc', md: 'none' }}
                  maxH="520px"
                />


                {/* Right Section - Campaign Form */}
                <Flex
                  direction="column"
                  flex={{ base: '100%', md: '50%' }}
                  width="100%"
                  maxH={{ base: 'unset', md: '520px' }}
                >
                  <AdspressoCampaignForm
                    values={campaignFormik.values}
                    setFieldValue={campaignFormik.setFieldValue}
                    handleChange={campaignFormik.handleChange}
                    handleBlur={campaignFormik.handleBlur}
                    errors={campaignFormik.errors}
                    touched={campaignFormik.touched}
                    dataCampaign={dataCampaign}
                    isLoadingCampaign={isLoadingCampaign}
                    errorCampaign={errorCampaign}
                    isSubmitting={campaignFormik.isSubmitting || isCreating}
                    handleSubmit={campaignFormik.handleSubmit}
                    createError={createError}
                    handleCloseModal={handleCloseModal}
                  />
                </Flex>
              </Flex>
            </ModalBody>

            <ModalFooter justifyContent="flex-start">
              <Flex direction="column">
                {campaignFormik.touched.adsAccounts && campaignFormik.errors.adsAccounts && (
                  <Flex gap={2} align="center">
                    <InfoOutlineIcon pointerEvents="all" fontSize="12px" color="red.500" />
                    <Text fontSize="12px" color="red.500">
                      {campaignFormik.errors.adsAccounts}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </ModalFooter>
          </ModalContent>
        </Modal>


        <Flex
          direction={["column", "row"]}
          justifyContent="space-between"
          alignItems={["flex-start", "center"]}
          mb={2}
          gap={[3, 0]}
          flexWrap="wrap"
        >
          {/* Left section */}
          {!isAdaccountError ? (
            <Flex alignItems="center" gap={4}>
              <Heading as="h1" size="xl">
                Launchpad
              </Heading>
                <Button colorScheme="brand" onClick={handleOpenModal} size="sm">
                <AddIcon boxSize={3} />
                &nbsp;Create
              </Button>
            </Flex>
          ) : (
            <Flex
              w="100%"
              justify="center"
              align="center"
              direction="column"
              h={'70vh'}
            >
              {fBData?.status === "deactive" && (
                <Flex direction="column" gap={4} align="center">
                  <Text fontSize="14px" textAlign="center">
                    Connect your Facebook BM to start hustlin’
                  </Text>
                  <Button
                    w="150px"
                    bg="rgb(25,119,242)"
                    color="white"
                    _hover={{ bg: "rgb(24, 102, 192)" }}
                    onClick={handleOpenFbBmModal}
                  >
                    Connect BM
                  </Button>
                </Flex>
              )}
            </Flex>
          )}

          {/* Right section */}
          <Flex
            direction={["column", "row"]}
            alignItems={["flex-start", "center"]}
            justifyContent="flex-end"
            gap={2}
          >
            {fBData?.status === "active" ? (
              <Button
                size="sm"
                borderRadius="md"
                colorScheme="brand"
                onClick={handleLogoutRelation}
                isLoading={isLoggingOut}
                loadingText="Disconnecting..."
              >
                {isLoggingOut ? "Disconnecting..." : "Disconnect from BM"}
              </Button>
            ) : isAdaccountError && fBData?.status !== "deactive" ? (
              <Button
                size="sm"
                borderRadius="md"
                colorScheme="brand"
                onClick={handleLogoutRelation}
                isLoading={isLoggingOut}
                loadingText="Disconnecting..."
              >
                {isLoggingOut ? "Disconnecting..." : "Disconnect from BM"}
              </Button>
            ) : null}
          </Flex>
        </Flex>

        {!isAdaccountError ?
          <Flex alignItems={'center'}>
            <Text fontSize={'14px'} color={textColor}>Scale Ads across various ad accounts with multiple creatives, an exclusive capability beyond Meta.</Text>
          </Flex>
          : null}

        {isAdaccountError && fBData?.status === 'active' ? (
          <Flex justify="center" align="center" height="80vh">
            <Text color="red.500">
              Please disconnect and reconnect your Facebook Business Manager account to continue accessing the platform.
            </Text>
          </Flex>
        ) : (
          null
        )}

        {isAdaccountError ? null :
          <Box py={"20px"}>
            <AdspressoTable adspressoCampaigns={adspressoCampaigns} isFetching={isFetching} isLoading={isLoading} setsearchValue={setsearchValue} setCurrentPage={setCurrentPage} onAdspressoData={handleAdspressoData} />
          </Box>
        }
      </>
      {/* )} */}
    </SidebarWithHeader>
  );

}
export default AdspressoForClient;